import { useEffect, useState, useRef } from 'react';
import ReactDOM from 'react-dom';
import { Constants, getBackendUrl } from '../util/Constants';
import { getCookie, setCookie, deleteCookie } from 'cookies-next';
import { useRouter } from 'next/router';
import {
  fetchData,
  getGlossaryLanguage,
  isItUndefined,
  isMobile,
  isTablet,
} from '../util/DataUtil';
import {
  autoPopulateAddActive,
  handleFocus,
  translateElements,
  handleChange,
  enableMarketoButton,
  translatePlaceholders,
  handleChangeModal,
  validateFormWithChecks,
  handleChangeRegisterLead,
  validateFormWithChecksCookie,
  translateRecaptcha,
  mergePrivacyAndCaptchaText,
} from '../util/MarketoUtil';
import { setMarketoCookieRedux } from '../store/marketoCookieSlice';
import { setVideoPlayingStateRedux } from '../store/gatedVideoPlayingStateSlice';
import { useDispatch, useSelector } from 'react-redux';
import { cleanHTML } from './utils/htmlUtils';
import CustomDropdown from './form/custom-dropdown';

const marketoScriptId = 'mktoForm';
// const fieldIds = [
//     '#Company_HQ_Country__c',
//     '#Company_HQ_State__c',
// ];

export default function MarketoModalForm({
  children,
  close,
  global,
  ctaPopUp,
  setShowDownloadItems,
  lang,
  seIsFormSubmitted,
  isTemplateInfo = false,
  globalWidth = null,
  setIsDomLoading,
  partnerName = null
}) {
  const formRef = useRef(null);
  const { asPath } = useRouter();
  let alias = asPath.substring(1);
  const [glossary, setGlossary] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isSubmittedLocal, setIsSubmittedLocal] = useState(false);
  const [firstName, setFirstName] = useState('');
  const [email, setEmail] = useState(false);
  const [marketoCookie, setMarketoCookie] = useState(false);
  const [checked, setChecked] = useState(false);
  const [accessToken, setAccessToken] = useState('');
  const [marketoFolderId, setMarketoFolderId] = useState('');
  const [marketoProgram, setMarketoProgram] = useState('');
  const marketoCookieState = useSelector(setMarketoCookieRedux);
  const videoPlayingState = useSelector(setVideoPlayingStateRedux);
  const dispatch = useDispatch();
  const [isItGated, setIsItGated] = useState(false);
  const [isItRegisterLead, setIsItRegisterLead] = useState(false);
  const [isItContactUs, setIsItContactUs] = useState(false);
  const [showEmailError, setShowEmailError] = useState(false);
  const [isFormLoaded, setIsFormLoaded] = useState(false);
  const [customDropdownValue, setCustomDropdownValue] = useState({});
  // const host = getBackendUrl(useSelector((state) => state.host.host));
  const [areDropdownFieldsReplaced, setAreDropdownFieldsReplaced] =
    useState(false);

  let formId = isItUndefined(children?.field_marketo_form_ids);
  let formToken = isItUndefined(global?.field_marketo_form_token);
  let formUrl = isItUndefined(global?.field_marketo_form_url);
  let downloadButtonText = isItUndefined(
    children?.field_marketo_download_button
  );

  let templateTitle = '';

  if (typeof document !== 'undefined') {
    let item = document.querySelector(
      '.gated_template .template-title .top h1'
    );
    templateTitle = item?.innerText;
  }

  if (typeof window !== 'undefined') {
    var host = getBackendUrl(window.location.host);
  }

  useEffect(() => {
    if (formRef.current && (isItRegisterLead || isItContactUs || isItGated)) {
      const mktoRows = document.querySelectorAll('form .mktoFormRow');
      const firstForm = document.querySelector('#register-lead form');
      let formWidth = 0;

      if (firstForm) {
        formWidth = firstForm.offsetWidth;
      }

      formRef.current.setValues({
        [customDropdownValue?.name]: customDropdownValue?.value,
      });

      handleCustomChangeLogic(mktoRows, formWidth, glossary, lang);
    }
  }, [customDropdownValue]);

  const fetchDataSecond = async () => {
    try {
      const response = await fetchData(
        host,
        'glossaries/v1/' + getGlossaryLanguage(lang),
        true
      );
      return response;
    } catch (error) {
      console.error('fetchDataSecond error:', error);
      return null;
    }
  };

  useEffect(() => {
    const fetchGlossaryData = async () => {
      if (lang !== 'en' && lang !== undefined && lang != 'nl') {
        try {
          const data = await fetchDataSecond();
          setGlossary(data || []);
        } catch (error) {
          console.error('Error fetching glossary data:', error);
          setGlossary([]);
        }
      } else {
        setGlossary([]);
      }
    };

    fetchGlossaryData();

    if (typeof document !== 'undefined') {
      // let gated = document.querySelector('.gated_template');
      let registeLead = document.querySelector('#register-lead');
      let contactUs = document.querySelector('.contact-us-form');
      let gatedTemplate = document.querySelector('.template-marketo');
      // if(gated !== null){
      //     setIsItGated(true)
      // }

      if (registeLead !== null) {
        setIsItRegisterLead(true);
      }
      if (contactUs !== null && formId === '2787') {
        setIsItContactUs(true);
      }
      if (gatedTemplate !== null) {
        setIsItGated(true);
      }
    }
  }, [lang]);

  useEffect(() => {
    const marketoIsSet = getCookie('marketoissetondlr');
    const marketoVals = getCookie('marketovals');
    let marketoValuesParesed = null;

    if (marketoVals) {
      setMarketoCookie(JSON.parse(marketoVals));
      marketoValuesParesed = JSON.parse(marketoVals);
    }

    if (
      marketoIsSet &&
      marketoValuesParesed &&
      marketoValuesParesed?.formid === '2786'
    ) {
      setIsSubmitted(marketoIsSet);
    } else {
      deleteCookie('_mkto_trk');
    }
  }, [isSubmitted]);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      let form = window.MktoForms2?.getForm(formId);

      if (
        marketoCookieState.payload.marketoCookieRedux.marketoCookieRedux
          .value !== undefined
      ) {
        form?.vals(
          marketoCookieState.payload.marketoCookieRedux.marketoCookieRedux.value
        );
      }
    }
  }, [marketoCookieState]);

  useEffect(() => {
    const marketoVals = getCookie('marketovals');
    if (isFormLoaded && marketoVals && formRef.current) {
      if (
        validateFormWithChecks(formRef.current.vals(), [
          'honeyPotSubmission',
          'utm_li_fat_id_most_recent__c',
          'utm_gclid_most_recent__c',
          'Preferred_location__c',
          'Power_Range__c',
        ])
      ) {
        enableMarketoButton(formId, {}, true);
      }
    }
  }, [isFormLoaded]);

  useEffect(() => {
    let fields = [];
    fields.push(document.querySelectorAll('form .mktoField'));
    // if (formId != '2786') {
    //   autoPopulateAddActive(fields);
    // }
  });

  const updateMktoRows = (mktoRows, formWidth) => {
    // const errorMsg = mktoRows[0].querySelector('.mktoErrorMsg');
    // errorMsg.style.display = 'none';
    mktoRows.forEach((element) => {
      element.classList.add('noField');

      let firstChild = element.firstElementChild;

      if (formId === '3203') {
        firstChild = element.childNodes[1];
      }
      const label = element.querySelector('[id*="LblmktoCheckbox"]');
      const textarea = element.querySelector('textarea');

      if (formId == 2801) {
        if (textarea) {
          textarea.placeholder = textarea.getAttribute('title') || '';

          let nextElement = textarea.nextElementSibling;
          for (let i = 0; i < 2 && nextElement; i++) {
            nextElement.setAttribute('style', 'display: none !important;');
            nextElement = nextElement.nextElementSibling;
          }
        }
      }

      const sectionTitle = element.querySelector('.mktoHtmlText');
      const checkboxElement = element.querySelector('input[type="checkbox"]');
      const labelsWithAsterix = element.querySelectorAll(
        '.mktoRequiredField label'
      );
      if (labelsWithAsterix) {
        labelsWithAsterix.forEach(function (lbl) {
          lbl.textContent = lbl.textContent.replace(/\*/g, '');
        });
      }

      if (
        firstChild &&
        (firstChild.classList.contains('mktoPlaceholder') ||
          (firstChild.tagName === 'INPUT' && firstChild.type === 'hidden'))
      ) {
        element.classList.add('noField');
      } else {
        element.classList.remove('noField');
      }

      // if (label) {
      //     label.setAttribute('style', `width: ${formWidth}px !important;`);
      // }

      if (textarea) {
        // element.setAttribute('style', `width: ${formWidth}px !important;`);
        firstChild.setAttribute('style', `width: 100%;`);

        if (formId === '3203' && textarea.id === 'formComments') {
          const textareaLabel = element.querySelector('label');
          textareaLabel.classList.add('alwaysActive');

          const descriptor = textarea.closest('.mktoFieldDescriptor');
          if (descriptor) {
            descriptor.style.width = '100%';
          }
        }
      }

      if (sectionTitle) {
        sectionTitle.classList.add('sectionTitle');
        element.classList.add('noBorder');
      }

      if (checkboxElement) {
        element.classList.add('noBorder');
        element.classList.add('checkboxMargin');
      }
    });
  };

  const updatePrivacyText = (mktoRows) => {
    mktoRows.forEach((element) => {
      const firstChild = element.firstElementChild;

      if (element.classList.contains('noBorder')) {
        element.classList.add('privacyText');
        // firstChild.setAttribute('style', `width: 100%;`);
      }
    });
  };

  const handleAddEventListener = (values) => {
    let fields = [];
    fields.push(document.querySelectorAll('form .mktoField'));

    fields[0].forEach((item) => {
      item.addEventListener('input', function (event) {
        if (
          formId === '2788' ||
          formId === '2786' ||
          formId === '3134' ||
          formId === '3148' ||
          formId === '3203'
        ) {
          handleChangeModal(formId, {}, values);
        } else if (formId === '2926') {
          handleChangeRegisterLead(formId);
        } else {
          handleChange(formId, event);
        }
        // handleSetDropdownValue(formId, customDropdownValue);
      });
    });
  };

  const handleAddHoverEffect = (mktoRows) => {
    mktoRows.forEach((element) => {
      const inputs = element.querySelectorAll('input, select, textarea');

      if (inputs.length > 0) {
        Array.from(element.children).forEach((child) => {
          const inputChild = child.querySelector('input');

          // Add hover effect only if the input is not a checkbox
          if (!inputChild || inputChild.type !== 'checkbox') {
            child.classList.add('addHover');
          }
        });
      }
    });
  };

  // Function to observe changes in the text content of an element (both label and options)
  const observeTextChange = (element, callback) => {
    if (!element) return;

    // Set up a MutationObserver to watch for changes in the element's text
    const observer = new MutationObserver((mutations) => {
      let changeDetected = false; // Flag to prevent multiple updates

      mutations.forEach((mutation) => {
        if (
          (mutation.type === 'childList' ||
            mutation.type === 'characterData') &&
          !changeDetected
        ) {
          // When text changes, execute the callback with the updated text
          changeDetected = true; // Prevent further execution
          callback(element.innerText || element.textContent);
          observer.disconnect(); // Stop observing after capturing the change
        }
      });
    });

    // Start observing the element for changes
    observer.observe(element, {
      childList: true,
      characterData: true,
      subtree: true,
    });
  };

  // Function to safely get text from an element with fallback
  const getSafeText = (element) => {
    return element ? element.innerText || element.textContent || '' : '';
  };

  // Optimized function to replace dropdown fields with custom components
  const replaceDropdownFields = (mktoRows) => {
    let isRequiredField = false;
    mktoRows.forEach((row) => {
      const dropdowns = row.querySelectorAll('.facility-modal select');

      // isRequiredField = dropdowns[1]?.className?.includes('mktoRequired');
      // if (dropdowns.length >= 1) {
      if (dropdowns.length >= 2) {
        dropdowns.forEach((e) => {
          isRequiredField = e?.className?.includes('mktoRequired');
        });
      } else if (formId === '3203' && dropdowns.length === 1) {
        dropdowns.forEach((e) => {
          isRequiredField = e?.className?.includes('mktoRequired');
        });
      }
      if (dropdowns.length > 0) {
        let preferredLocationParent = null;
        // Hide the original mktoFormRow that contains the select elements
        // row.style.display = 'none';

        // Create or find the custom container that will hold the dropdowns
        let customContainer = row.nextElementSibling;
        if (
          !customContainer ||
          !customContainer.classList.contains('custom-selector-container')
        ) {
          customContainer = document.createElement('div');
          customContainer.classList.add(
            'mktoFormRow',
            'custom-selector-container'
          );
          row.insertAdjacentElement('afterend', customContainer);
        }

        // Iterate through each select element in the row
        dropdowns.forEach((dropdown) => {
          const fieldId = dropdown?.id;
          const label = document.querySelector(`label[for="${dropdown.id}"]`); // Find the label for the dropdown
          let optionsProps = [];
          let hideElement = dropdown.closest('.mktoFieldDescriptor');
          const selectElement = document.getElementById(
            'Preferred_location__c'
          );

          if (formId === '3203') {
            const preferredLocationLabel = document.getElementById(
              'LblPreferred_location__c'
            );
            if (preferredLocationLabel) {
              preferredLocationLabel.classList.add('active');
            }
          }

          if (selectElement) {
            selectElement.options[0].disabled = true;
            if (formId !== '3203') selectElement.selectedIndex = -1;
          }
          // if (dropdown?.id === 'Preferred_location__c') {
          // preferredLocationParent = hideElement;
          // return; //
          // }
          // Hide the mktoFieldDescriptor containing the select element
          if (hideElement) {
            hideElement.style.display = 'none';
          }

          // Collect the options for the custom dropdown and observe changes in text
          const options = dropdown.options;
          for (let i = 0; i < options.length; i++) {
            const option = options[i];
            optionsProps.push({
              id: i,
              label: getSafeText(option),
              value: option.value,
            });

            // Observe changes in each option's text to capture translations
            observeTextChange(option, (translatedOptionText) => {
              if (
                translatedOptionText &&
                translatedOptionText !== optionsProps[i].label
              ) {
                optionsProps[i].label = translatedOptionText; // Update label if changed
              }
            });
          }

          // Check if the dropdown wrapper already exists to avoid duplication
          let dropdownWrapper = customContainer.querySelector(
            `.custom-dropdown-wrapper[data-field-id="${fieldId}"]`
          );
          if (!dropdownWrapper) {
            // Create a wrapper for the dropdown with a unique ID and consistent class
            dropdownWrapper = document.createElement('div');
            dropdownWrapper.id = `custom-selector-${fieldId}`;
            dropdownWrapper.classList.add(
              'custom-dropdown-wrapper',
              'mktoFormCol',
              'addHover'
            ); // Add necessary classes
            dropdownWrapper.setAttribute('data-field-id', fieldId); // Set a unique data attribute to avoid duplication
            dropdownWrapper.id = `custom-wrapper-${fieldId}`; // Set a unique ID to avoid duplication
            // if (fieldId == 'Power_Range__c') {
            //   dropdowtnWrapper.style.display = 'none';
            // }
            customContainer.appendChild(dropdownWrapper); // Append directly to the custom container

            // Create a container inside the wrapper for rendering the dropdown
            let dropdownContainer = document.createElement('div');
            dropdownContainer.id = `custom-dropdown-${fieldId}`; // Set a unique ID based on fieldId
            // if (fieldId == 'Power_Range__c') {
            //   hideElement.parentElement.prepend(dropdownContainer);
            // } else {
            dropdownWrapper.appendChild(dropdownContainer);
            // }

            // Initial label text capture with fallback
            let labelText = getSafeText(label).replace(/^\*/, '');

            // Observer to ensure we capture the translated label text
            observeTextChange(label, (translatedLabelText) => {
              if (translatedLabelText && translatedLabelText !== labelText) {
                labelText = translatedLabelText; // Update label text if changed
              }

              // Render the custom dropdown component inside its container
              ReactDOM.render(
                <CustomDropdown
                  setCustomDropdownValue={setCustomDropdownValue}
                  options={optionsProps}
                  fieldId={fieldId}
                  label={labelText}
                  formId={formId}
                  isContactUsNav={true}
                  isRequired={isRequiredField}
                  // isModal={true}
                  isMultiselect={dropdown.multiple}
                />,
                dropdownContainer
              );
            });

            // Render initially in case observer doesn't trigger
            ReactDOM.render(
              <CustomDropdown
                setCustomDropdownValue={setCustomDropdownValue}
                options={optionsProps}
                fieldId={fieldId}
                label={labelText}
                formId={formId}
                isContactUsNav={true}
                isRequired={isRequiredField}
                isMultiselect={dropdown.multiple}
                // isModal={true}
              />,
              dropdownContainer
            );
          }
        });
      }
    });
  };

  const cleanUpCustomDropdowns = () => {
    const customDropdownContainers = document.querySelectorAll(
      '.custom-selector-container'
    );

    customDropdownContainers.forEach((container) => {
      const fieldId = container.id.replace('custom-selector-', '');
      if (!fieldId) return;
      const originalSelect = document.querySelector(`select#${fieldId}`);

      // If the original <select> is not found, remove the custom container
      if (!originalSelect) {
        container.remove();
      }
    });
  };

  // Function to observe changes in the form and clean up if necessary
  const setupFormObserver = () => {
    const formElement = document.querySelector('.register-lead form');

    if (!formElement) return;

    // Create a MutationObserver to observe changes in the form
    const observer = new MutationObserver((mutations) => {
      let needsCleanup = false;

      // Check if any child nodes were added or removed
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
          needsCleanup = true;
        }
      });

      // If changes were detected, clean up orphaned custom dropdowns
      if (needsCleanup) {
        cleanUpCustomDropdowns();
      }
    });

    // Start observing the form for child node changes
    observer.observe(formElement, { childList: true, subtree: true });

    // Perform initial cleanup when the observer is first set up
    cleanUpCustomDropdowns();
  };

  // Initialize the observer in useEffect
  useEffect(() => {
    setupFormObserver();

    return () => {
      const existingScript = document.getElementById(marketoScriptId);
      if (existingScript) {
        document.head.removeChild(existingScript);
      }

      delete window.MktoForms2;
    };
  }, []);

  useEffect(() => {
    if (formRef.current && glossary.length > 0) {
      const labels = document.querySelectorAll('form label');
      const buttons = document.querySelectorAll('form button');
      const options = document.querySelectorAll('form select option');
      const span = document.querySelectorAll('form div.mktoHtmlText span>span');
      const span2 = document.querySelectorAll('form div.mktoHtmlText');
      const strong = document.querySelectorAll('form strong');
      const input = document.querySelectorAll('form input');
      const textArea = document.querySelectorAll('form textarea');
      const recaptcha = document.querySelector('.mktoCaptchaDisclaimer');

      translateRecaptcha(recaptcha, glossary, lang);
      translateElements(labels, glossary, lang);
      translateElements(buttons, glossary, lang);
      translateElements(options, glossary, lang);
      translateElements(span, glossary, lang);
      translateElements(span2, glossary, lang);
      translateElements(strong, glossary, lang);
      translatePlaceholders(textArea, glossary, lang);
      translatePlaceholders(input, glossary, lang);
    }
  }, [glossary, lang, areDropdownFieldsReplaced]);

  const handleCustomChangeLogic = (mktoRows, formWidth, glossary, lang) => {
    let fields = [];
    // let checkbox = document.querySelector('input[type="checkbox"]');

    fields.push(document.querySelectorAll('form .mktoField'));

    // Add event listener to the checkbox for change event
    // checkbox?.addEventListener('change', function() {
    //     enableMarketoButton(formId, event, checkbox.checked);
    // });

    // Run other functions to update rows and add event listeners
    updateMktoRows(mktoRows, formWidth);
    handleAddEventListener(formRef?.current?.vals());
    handleAddHoverEffect(mktoRows);
    handleFocus(fields, glossary, lang);
    replaceDropdownFields(mktoRows);
    autoPopulateAddActive(fields);
  };

  function fetchDataFunction(props, glossary, lang) {
    // let id = marketoScriptId + "_" + formId;
    // let form = typeof  window !== 'undefined' ? document.querySelector('#facility-marketo form') : '';

    useEffect(() => {
      if (!document.getElementById(marketoScriptId)) {
        // if (!document.getElementById(id)) {
        // if (!!document.getElementById(id)) {
        // if (!!document.getElementById(id) && form?.children?.length === 0) {
        loadScript();
      } else {
        setIsLoaded(true);
      }
    }, []);

    useEffect(() => {
      if (isLoaded && glossary) {
        setTimeout(() => {
          window.MktoForms2?.loadForm(
            '//' + formUrl,
            formToken,
            formId,
            function (form) {
              formRef.current = form;
              let formHeader;
              let formHeaderSubtitle;

              let removeClass = document.querySelectorAll(
                'form .mktoButtonRow .mktoButtonWrap'
              );
              removeClass.forEach((child) => {
                child.classList.remove('mktoSimple');
              });

              if (!ctaPopUp) {
                formHeader = document.querySelector('.form-header .title');
              } else {
                formHeader = document.querySelector('.form-header .cta-title');
              }

              if (formHeader) {
                formHeader.innerHTML = props.marketo_header_text
                  ? props.marketo_header_text
                  : props.field_marketo_header_text?.length !== 0
                    ? isItUndefined(props.field_marketo_header_text)
                    : '';
              }

              if (!ctaPopUp) {
                formHeaderSubtitle = document.querySelector(
                  '.form-header .subtitle'
                );
              } else {
                formHeaderSubtitle = document.querySelector(
                  '.form-header .cta-subtitle'
                );
              }

              if (formHeaderSubtitle) {
                formHeaderSubtitle.innerHTML = props.marketo_subtitle_text
                  ? props.marketo_subtitle_text
                  : props.field_marketo_subtitle_text?.length !== 0
                    ? isItUndefined(props.field_marketo_subtitle_text)
                    : '';

                if (formHeaderSubtitle.innerHTML.length === 0) {
                  formHeaderSubtitle.style.display = 'none';
                }
              }

              if (
                formHeader?.innerHTML.length === 0 &&
                formHeaderSubtitle?.innerHTML.length === 0
              ) {
                if (!ctaPopUp) {
                  document.querySelector('.form-header').style.display = 'none';
                }
                let width = window.innerWidth;
                if (width <= 992) {
                  document.querySelector('form').style.paddingTop = '30px';
                }
              }

              let labels = document.querySelectorAll('form label');
              let buttons = document.querySelectorAll('form button');
              let options = document.querySelectorAll('form select option');
              let span = document.querySelectorAll(
                'form div.mktoHtmlText span>span'
              );
              let span2 = document.querySelectorAll('form div.mktoHtmlText');
              let strong = document.querySelectorAll('form strong');
              let select = document.querySelectorAll('form select');
              let textarea = document.querySelectorAll('form textarea');
              let checkbox = document.querySelectorAll(
                'form .mktoCheckboxList label'
              );
              let recaptcha = document.querySelector('.mktoCaptchaDisclaimer');

              // ---------------------------- REGISTER A LEAD V2 ----------------------------
              if (isItRegisterLead) {
                const mktoRows = document.querySelectorAll('form .mktoFormRow');
                const firstForm = document.querySelector('#register-lead form');
                let formWidth = firstForm ? firstForm.offsetWidth : 0;

                updateMktoRows(mktoRows, formWidth);
                updatePrivacyText(mktoRows);
                handleAddHoverEffect(mktoRows);
                replaceDropdownFields(mktoRows);
              }

              if (isItContactUs) {
                const mktoRows2 =
                  document.querySelectorAll('form .mktoFormRow');
                const contactUsForm = document.querySelector(
                  '#contact-us-form form'
                );
                let formWidth2 = contactUsForm ? contactUsForm.offsetWidth : 0;

                updateMktoRows(mktoRows2, formWidth2);
                updatePrivacyText(mktoRows2);
                handleAddHoverEffect(mktoRows2);
                replaceDropdownFields(mktoRows2);
              }

              if (isItGated) {
                const mktoRows3 =
                  document.querySelectorAll('form .mktoFormRow');
                const gatedForm = document.querySelector('.gated form');
                let formWidth3 = gatedForm ? gatedForm.offsetWidth : 0;

                updateMktoRows(mktoRows3, formWidth3);
                updatePrivacyText(mktoRows3);
                handleAddHoverEffect(mktoRows3);
                replaceDropdownFields(mktoRows3);
              }

              if (ctaPopUp) {
                const mktoRows4 =
                  document.querySelectorAll('form .mktoFormRow');
                const facilityModal = document.querySelector(
                  '.facility-modal form'
                );
                let formWidth4 = facilityModal ? facilityModal.offsetWidth : 0;

                updateMktoRows(mktoRows4, formWidth4);
                updatePrivacyText(mktoRows4);
                handleAddHoverEffect(mktoRows4);
                replaceDropdownFields(mktoRows4);
              }

              let downloadButton = document.querySelector(
                'form[id*=' + CSS.escape(formId) + '] .mktoButton'
              );
              if (downloadButtonText && downloadButton) {
                downloadButton.innerHTML = downloadButtonText;
              }

              select.forEach((el) => {
                let elem = el.parentElement.firstChild;
                elem.classList.add('active');
              });

              if (formId === '3203') {
                const checkboxLabel =
                  document.getElementById('LbltemporaryField5');
                checkbox[0].textContent = checkboxLabel.lastChild.textContent;
                checkboxLabel.lastChild.textContent = '';
              }

              checkbox.forEach((el) => {
                el.classList.add('active');
              });

              translateElements(labels, glossary, lang);
              translateElements(buttons, glossary, lang);
              translateElements(options, glossary, lang);
              translateElements(span, glossary, lang);
              translateElements(span2, glossary, lang);
              translateElements(strong, glossary, lang);
              translateRecaptcha(recaptcha, glossary, lang);

              let fields = [document.querySelectorAll('form .mktoField')];

              fields[0].forEach((item) => {
                item.addEventListener('input', function (event) {
                  if (
                    formId === '2788' ||
                    formId == '2787' ||
                    formId === '3134' ||
                    formId === '3147' ||
                    formId === '3148' ||
                    formId === '3203'
                  ) {
                    handleChangeModal(formId, {}, form.vals());
                  } else if (formId === '2926') {
                    handleChangeRegisterLead(formId);
                  } else {
                    handleChange(formId, event);
                  }
                });
              });

              if (formId === '3203') {
                handleCheckboxControlledFields();
              }

              if (marketoCookie) {
                autoPopulateAddActive(fields);
              }

              if (!form) return;

              if (marketoCookie) {
                delete marketoCookie.formid;
              }
              form.vals(marketoCookie);

              handleFocus(fields, glossary, lang);

              form.onValidate(function (builtInValid) {
                var firstNameInput =
                  document.querySelector('[name="FirstName"]');
                var lastNameInput = document.querySelector('[name="LastName"]');
                var companyInput = document.querySelector('[name="Company"]');

                if (firstNameInput && lastNameInput && companyInput) {
                  // ... (ostaje identično kao kod)
                  // VALIDATION LOGIKA OSTAVLJENA ISTA
                }
              });

              if (formId === '2813' || formId === '2926') {
                form.onValidate(function (builtInValid) {
                  var partnerEmailInput = document.querySelector(
                    '[name="Partner_Email__c"]'
                  );
                  var emailInput = document.querySelector('[name="Email"]');
                  if (partnerEmailInput && emailInput) {
                    // ... (ostaje isto kao tvoj originalni kod za validation)
                  }
                });
              }

              mergePrivacyAndCaptchaText(formId);

              setIsFormLoaded(true);
              setIsDomLoading(false);
              form.onSubmit(function () {
                const buttons = document.querySelectorAll(
                  '#mktoForm_' + formId + ' button'
                );
                buttons[0].disabled = true;
                setIsSubmittedLocal(true);
                if (ctaPopUp) {
                  children.data.setIsSubmitted(true);
                }
                let submitVals = form.vals();
                setFirstName(submitVals.FirstName);
              });

              form.onSuccess(function (values, followUpUrl) {
                let vals = form.vals();
                if (vals?.Pref_Optin_Pending__c) {
                  vals.Pref_Optin_Pending__c = 'no';
                }
                if (vals?.KR_Partner_Type__c) {
                  vals.KR_Partner_Type__c = '';
                }
                const buttons = document.querySelectorAll(
                  '#mktoForm_' + formId + ' button'
                );
                buttons[0].disabled = false;

                if (!ctaPopUp) {
                  if (!alias) {
                    props.data.setTrigger(false);
                    props.data.setIsSubmitted(true);
                    return false;
                  }
                  if (children.data) {
                    children.data.setTrigger(false);
                    children.data.setIsSubmitted(true);
                    return false;
                  }
                } else if (ctaPopUp) {
                  children.data.setIsSubmitted(true);
                }

                if (isTemplateInfo) {
                  seIsFormSubmitted(true);
                }

                setIsSubmittedLocal(true);
                setFirstName(vals.FirstName);
                setEmail(vals.Email);

                const today = new Date();
                const tomorrow = new Date(today);
                tomorrow.setDate(tomorrow.getDate() + 1);

                let date =
                  Number(
                    isItUndefined(global.field_marketo_cookie_expiration)
                  ) !== 0
                    ? new Date(
                        new Date().getTime() +
                          (Number(
                            isItUndefined(
                              global.field_marketo_cookie_expiration
                            )
                          ) +
                            1) *
                            60 *
                            60 *
                            1000
                      )
                    : tomorrow;

                setCookie('marketoissetondlr', 'true', { expires: date });
                setCookie('marketovals', vals, { expires: date });

                localStorage.setItem('newMarketoVals', JSON.stringify(vals));

                let obj = { name: 'marketovals', value: vals };
                dispatch(setMarketoCookieRedux(obj));

                let anchorFacility =
                  document.getElementById('facility-marketo')?.offsetTop;
                let anchorTemplate =
                  document.getElementById('template-marketo')?.offsetTop;
                let anchorContactInfoTemplate = document.getElementById(
                  'template-contact-info'
                )?.offsetTop;

                if (anchorFacility) {
                  window.scrollTo({
                    top: anchorFacility - 200,
                    behavior: 'smooth',
                  });
                } else if (anchorTemplate) {
                  window.scrollTo({
                    top: anchorTemplate - 100,
                    behavior: 'smooth',
                  });
                } else if (anchorContactInfoTemplate) {
                  window.scrollTo({
                    top: anchorContactInfoTemplate - 100,
                    behavior: 'smooth',
                  });
                }

                fields[0].forEach((item) => {
                  item.removeEventListener('input', handleChange);
                });

                // console.log("submited vals", form.vals())
                return false;
              });
            }
          );
        }, 100);
      }
    }, [isLoaded, glossary]);

    const loadScript = () => {
      var s = document.createElement('script');
      s.id = marketoScriptId;
      s.type = 'text/javascript';
      s.async = true;
      s.src = '//app-sj11.marketo.com/js/forms2/js/forms2.min.js';
      s.onreadystatechange = function () {
        if (this.readyState === 'complete' || this.readyState === 'loaded') {
          setIsLoaded(true);
        }
      };
      s.onload = () => setIsLoaded(true);
      document.getElementsByTagName('head')[0].appendChild(s);
    };

    return isLoaded;
  }

  function addActiveClassToNewElements() {
    let select = document.querySelectorAll('.marketo-form select');
    let textarea = document.querySelectorAll('.marketo-form textarea');
    let checkbox = document.querySelectorAll(
      '.marketo-form .mktoCheckboxList label'
    );

    select.forEach((el) => {
      el.addEventListener('change', (e) => handleClick(e, 'United States'));
      let elem = el.parentElement.firstChild;
      elem.classList.add('active');
    });

    textarea.forEach((el) => {
      let elem = el.parentElement.firstChild;
      elem.classList.add('active');
    });

    checkbox.forEach((el) => {
      el.classList.add('active');
    });
  }

  function handleClick(e, country) {
    let result = '';
    for (let item of e.target) {
      if (item.innerText === country) {
        result = item.innerText;
      }
    }

    addActiveClassToNewElements();
  }

  function addFirstNameAutomatically(data) {
    if (!data) {
      return;
    }

    let templateTitle = '';

    if (document.querySelector('.template-title h1')) {
      templateTitle = document.querySelector('.template-title h1').innerHTML;
    }

    data = data.replace(
      '{first_name}',
      firstName !== undefined ? firstName : ''
    );
    data = data.replace(
      '{H1}',
      templateTitle !== undefined ? templateTitle : ''
    );
    data = data.replace(
      '[[field_partner_name]]',
      partnerName ? partnerName : ''
    );

    return data;
    // return data.replace("{first_name}", firstName !== undefined ? firstName : "");
  }

  function addFirstNameAutomaticallyKnownUser(data) {
    let firstNameLocal = '';
    let firstNameLocalNew = '';

    if (!data) {
      return;
    }

    if (getCookie('marketovals')) {
      firstNameLocal = JSON.parse(getCookie('marketovals'));
    }

    // if(getCookie('newMarketoVals')){
    //     firstNameLocalNew = JSON.parse(getCookie('newMarketoVals'));
    // }

    if (localStorage.getItem('newMarketoVals')) {
      firstNameLocalNew = JSON.parse(localStorage.getItem('newMarketoVals'));
    }

    // let templateTitle = document.querySelector('.template-title h1').innerHTML;

    let templateTitle = '';

    if (document.querySelector('.template-title h1')) {
      templateTitle = document.querySelector('.template-title h1').innerHTML;
    }

    // data = data.replace("{first_name}", firstNameLocal.FirstName !== undefined ? firstNameLocal.FirstName : newMarketoVals.FirstName !== undefined ? newMarketoVals.FirstName : "")
    const firstNameToReplace =
      firstNameLocal.FirstName ?? firstNameLocalNew.FirstName ?? '';

    data = data.replace('{first_name}', firstNameToReplace);
    data = data.replace(
      '{H1}',
      templateTitle !== undefined ? templateTitle : ''
    );

    // return data.replace("{first_name}", firstNameLocal.FirstName !== undefined ? firstNameLocal.FirstName : "");
    return data;
  }

  function handleVideo(video) {
    // let video;

    // if (children?.field_marketo_file_url[0]?.value) {
    //   video = children?.field_marketo_file_url[0]?.value;
    // }

    if (video) {
      const innerVertical = document.querySelector('.inner-vertical'); // Pronalazimo .inner-vertical element
      //check if iframe with class videoIframe already exists
      const existingIframe = document.querySelector('.videoIframe');
      if (existingIframe) {
        console.log('Iframe already exists on the page.');
        return; //break function execution if iframe exists
      }

      if (innerVertical) {
        //creating wrapper div for aspect ratio
        const wrapper = document.createElement('div');
        wrapper.style.position = 'relative';
        wrapper.style.width = '100%';
        wrapper.style.paddingTop = '56.25%'; // 16:9 aspect ratio (9 / 16 = 0.5625)

        // creating new iframe
        const iframe = document.createElement('iframe');
        iframe.classList.add('videoIframe');
        iframe.style.position = 'absolute';
        iframe.style.top = '0';
        iframe.style.left = '0';
        iframe.style.width = '100%';
        iframe.style.height = '100%';
        iframe.setAttribute('frameborder', '0');
        iframe.setAttribute('allow', 'autoplay');
        iframe.setAttribute('allowfullscreen', 'allowfullscreen');

        iframe.onload = function () {
          iframe.scrollIntoView({ behavior: 'smooth', block: 'center' });
        };

        let embedUrl;
        if (video.includes('youtube.com') || video.includes('youtu.be')) {
          // YouTube
          const videoId = video.includes('v=')
            ? video.split('v=')[1].split('&')[0] // ID extraction from  "v=..." part
            : video.split('/').pop();
          embedUrl = `https://www.youtube.com/embed/${videoId}`;
        } else if (video.includes('vimeo.com')) {
          // Vimeo
          const videoParts = video.split('/');
          const videoId = videoParts[3]; // VIDEO_ID extraction from url
          const hash =
            videoParts.length > 4 ? videoParts[4].split('?')[0] : null; // hash extraction from url if exists
          embedUrl = hash
            ? `https://player.vimeo.com/video/${videoId}?h=${hash}`
            : `https://player.vimeo.com/video/${videoId}`;
        } else {
          console.error('Unsupported video platform.');
          return;
        }

        iframe.setAttribute('src', embedUrl);

        wrapper.appendChild(iframe);

        innerVertical.parentNode.insertBefore(wrapper, innerVertical);
      } else {
        console.error('Element with class .inner-vertical not found.');
      }
    }
  }

  function isYouTubeOrVimeoUrl(url) {
    const youtubePattern =
      /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
    const vimeoPattern = /(?:https?:\/\/)?(?:www\.)?vimeo\.com\/(\d+)/;

    return youtubePattern.test(url) || vimeoPattern.test(url);
  }

  function downloadAndEmailFile(hiddenSubmit) {
    // let link = "mailto:" + email;
    let file;

    // let formId = isItUndefined(children.field_marketo_form_ids);
    // let formToken = isItUndefined(global.field_marketo_form_token);
    // let formUrl = isItUndefined(global.field_marketo_form_url);

    // if(checked){
    //     window.location.href = link;
    // }

    if (children?.field_marketo_download_file[0]?.value) {
      file = children?.field_marketo_download_file[0]?.value;
    }

    if (children?.field_marketo_file_url[0]?.value) {
      file = children?.field_marketo_file_url[0]?.value;
    }

    if (!isYouTubeOrVimeoUrl(file) && hiddenSubmit) {
      window.MktoForms2.loadForm(
        '//' + formUrl,
        formToken,
        formId,
        function (form) {
          form.setValues(marketoCookie);

          if (form.submittable()) {
            form.submit();
          }
        }
      );
    }

    children.data?.setTrigger(false);

    // window.open(file, '_blank');
    if (file) {
      if (isYouTubeOrVimeoUrl(file)) {
        handleVideo(file); // Pokreće video ako je YouTube ili Vimeo
      } else {
        window.open(file, '_blank'); // Otvara fajl ako nije video URL
      }
    }
  }

  function showDownloadButtonAndCheckbox(text) {
    let file;

    if (children?.field_marketo_download_file[0]?.value) {
      file = children?.field_marketo_download_file[0]?.value;
    }

    if (children?.field_marketo_file_url[0]?.value) {
      file = children?.field_marketo_file_url[0]?.value;
    }

    return !!(file && isItUndefined(text));
  }

  function handleCheckboxControlledFields() {
    const showFieldsCheckbox = document.querySelector(
      'input[id="temporaryField5"][type="checkbox"]'
    );
    let savedValues = {};

    if (!showFieldsCheckbox) return;
    // Track active operations
    let isUpdating = false;
    let observer;

    const getPlaceholderRow = () => {
      const placeholderRow = [];

      document
        .querySelectorAll(
          '.mktoPlaceholderPreferred_location__c, #Preferred_location__c'
        )
        .forEach((el) => {
          const row = el.closest('.mktoFormRow');
          if (row) {
            placeholderRow.push(row);
          }
        });

      return placeholderRow;
    };

    const getCustomRow = () => {
      const wrapper = document.querySelector(
        '#custom-wrapper-Preferred_location__c'
      );

      if (!wrapper) {
        return null;
      }
      return wrapper.closest('.mktoFormRow');
    };

    const processFields = () => {
      if (isUpdating) return;
      isUpdating = true;

      requestAnimationFrame(() => {
        try {
          const form = window.MktoForms2?.getForm(formId);

          const customRow = getCustomRow();
          const row = getPlaceholderRow();
          updateMktoRows(row);
          handleAddHoverEffect(row);
          replaceDropdownFields(row);

          if (customRow) {
            if (!showFieldsCheckbox.checked) {
              customRow.remove();
            }
          }

          const infoDiv = document.querySelector(
            '.mktoHtmlText.mktoHasWidth:has(strong)'
          );
          if (infoDiv) {
            infoDiv.style.textAlign = 'start';
          }
        } finally {
          isUpdating = false;
        }
      });
    };

    // Initialize form handling
    const initFormHandling = () => {
      // Cleanup previous observer
      if (observer) observer.disconnect();

      const formContainer = document.querySelector('.mktoForm');
      if (!formContainer) return;

      // New observer
      observer = new MutationObserver((mutations) => {
        if (
          mutations.some((m) => m.addedNodes.length || m.removedNodes.length)
        ) {
          processFields();
        }
      });

      observer.observe(formContainer, {
        childList: true,
        subtree: true,
      });

      // Always process on init (regardless of checkbox state)
      processFields();

      // Additional check for checkbox state after a delay
      // setTimeout(() => {
      //   if (showFieldsCheckbox.checked) {
      //     processFields();
      //   }
      // }, 300);
    };

    // Set up change listener
    const handleChange = () => {
      processFields();
      // Reinitialize observer in case form was recreated
      setTimeout(initFormHandling, 100);
    };

    showFieldsCheckbox.addEventListener('change', handleChange);

    // Initialize when form is ready
    const checkFormReady = () => {
      if (document.querySelector('.mktoForm')) {
        initFormHandling();
      } else {
        setTimeout(checkFormReady, 100);
      }
    };

    checkFormReady();

    // Cleanup function to call when modal closes
    return () => {
      if (observer) observer.disconnect();
      showFieldsCheckbox.removeEventListener('change', handleChange);
    };
  }

  function renderSuccessMessage() {
    return (
      <div className={'success-message-header'}>
        <div className={'facility-marketo-success'}>
          {formId == '2788' ? (
            <h1
              dangerouslySetInnerHTML={{
                __html: `${cleanHTML(
                  addFirstNameAutomatically(
                    isItUndefined(children.field_marketo_message_title_text)
                  )
                )} <span>${cleanHTML(
                  addFirstNameAutomatically(
                    isItUndefined(children.field_marketo_message_subtitle_t)
                  )
                )}</span>`,
              }}
            />
          ) : (
            <>
              <h1
                dangerouslySetInnerHTML={{
                  __html: cleanHTML(
                    addFirstNameAutomatically(
                      isItUndefined(children.field_marketo_message_title_text)
                    )
                  ),
                }}
              />
              <h3
                className={'subtitle'}
                dangerouslySetInnerHTML={{
                  __html: cleanHTML(
                    addFirstNameAutomatically(
                      isItUndefined(children.field_marketo_message_subtitle_t)
                    )
                  ),
                }}
              />
            </>
          )}
          <div
            className={'text'}
            dangerouslySetInnerHTML={{
              __html: cleanHTML(
                addFirstNameAutomatically(
                  isItUndefined(children.field_marketo_message_body_text)
                )
              ),
            }}
          />
          {showDownloadButtonAndCheckbox(
            children.field_marketo_message_button_tex
          ) && (
            <div
              className={'div-marketo-link downloadButton'}
              onClick={() => downloadAndEmailFile()}
              dangerouslySetInnerHTML={{
                __html: addFirstNameAutomatically(
                  isItUndefined(children.field_marketo_message_button_tex)
                ),
              }}
            />
          )}
          <div className={'privacy-text'}>
            <p
              dangerouslySetInnerHTML={{
                __html: cleanHTML(
                  addFirstNameAutomatically(
                    isItUndefined(children.field_marketo_privacy_text)
                  )
                ),
              }}
            />
          </div>
        </div>
      </div>
    );
  }

  function renderKnownUserMessage() {
    return (
      <div className={'success-message-header'}>
        <div className={'facility-marketo-success'}>
          <h1
            dangerouslySetInnerHTML={{
              __html: cleanHTML(
                addFirstNameAutomaticallyKnownUser(
                  isItUndefined(children.field_marketo_known_user_title)
                )
              ),
            }}
          />
          <h3
            className={'subtitle'}
            dangerouslySetInnerHTML={{
              __html: cleanHTML(
                addFirstNameAutomaticallyKnownUser(
                  isItUndefined(children.field_marketo_known_user_subtitl)
                )
              ),
            }}
          />
          <div
            className={'text'}
            dangerouslySetInnerHTML={{
              __html: cleanHTML(
                addFirstNameAutomaticallyKnownUser(
                  isItUndefined(children.field_marketo_known_user_message)
                )
              ),
            }}
          />
          {showDownloadButtonAndCheckbox(
            children.field_marketo_known_user_button_
          ) && (
            <div
              className={'div-marketo-link downloadButton'}
              onClick={() => downloadAndEmailFile(true)}
              dangerouslySetInnerHTML={{
                __html: addFirstNameAutomaticallyKnownUser(
                  isItUndefined(children.field_marketo_known_user_button_)
                ),
              }}
            />
          )}
          <div className={'privacy-text'}>
            <p
              dangerouslySetInnerHTML={{
                __html: cleanHTML(
                  addFirstNameAutomaticallyKnownUser(
                    isItUndefined(children.field_marketo_known_user_privacy)
                  )
                ),
              }}
            />
          </div>
        </div>
      </div>
    );
  }

  function autoPopulate() {
    return !(
      children.field_marketo_download_file.length !== 0 ||
      children.field_marketo_file_url.length !== 0
    );
  }

  function renderMessage() {
    if (isSubmittedLocal) {
      if (setShowDownloadItems !== undefined) {
        setShowDownloadItems(true);
      }
      {
        /* DXP-3108 - REMOVE FOR PRODUCTION */
      }
      return renderSuccessMessage();
      // return videoPlayingState.payload.gatedVideoPlayingStateSlice.videoPlayingStateRedux === false ? renderSuccessMessage() : '';

      // if (isItGated) {
      //     const videoState = videoPlayingState.payload.gatedVideoPlayingStateSlice.videoPlayingStateRedux;

      //     if (videoState === false || (typeof videoState !== 'boolean' && Object.keys(videoState).length === 0)) {
      //         return renderSuccessMessage();
      //     }

      //     return '';
      // } else {
      //     return renderSuccessMessage();
      // }
    } else if (isSubmitted) {
      if (autoPopulate() === false) {
        if (setShowDownloadItems !== undefined) {
          setShowDownloadItems(true);
        }
        {
          /* DXP-3108 - REMOVE FOR PRODUCTION */
        }
        return renderKnownUserMessage();
        // return videoPlayingState.payload.gatedVideoPlayingStateSlice.videoPlayingStateRedux === false ? renderKnownUserMessage() : '';

        // if (isItGated) {
        //     const videoState = videoPlayingState.payload.gatedVideoPlayingStateSlice.videoPlayingStateRedux;

        //     if (videoState === false || (typeof videoState !== 'boolean' && Object.keys(videoState).length === 0)) {
        //         return renderKnownUserMessage();
        //     }

        //     return '';
        // } else {
        //     return renderKnownUserMessage();
        // }
      }
    }

    return '';
  }

  function showForm() {
    if (isSubmittedLocal) {
      return 'none';
    }

    if (isSubmitted) {
      if (!autoPopulate()) {
        return 'none';
      }
    }

    return '';
  }

  fetchDataFunction(children, glossary, lang);

  return (
    <>
      {!ctaPopUp && !isSubmittedLocal && !isSubmitted && (
        <div className={'form-header modal-header'}>
          <div>
            <p className={'title'} />
            <p className={'subtitle'} />
          </div>
          {ctaPopUp && close !== undefined && (
            <svg
              onClick={() => {
                close();
              }}
              className={'escape'}
              alt={'escape'}
              width="12"
              height="12"
              viewBox="0 0 12 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M1.52387 1.08985L5.99974 5.56572L10.4761 1.08985C10.5959 0.970048 10.7902 0.970048 10.9101 1.08985C11.03 1.20976 11.03 1.40405 10.9101 1.52387L6.43375 5.99974L10.9101 10.4761C11.03 10.5959 11.03 10.7902 10.9101 10.9101C10.7902 11.03 10.5959 11.03 10.4761 10.9101L5.99974 6.43375L1.52387 10.9101C1.40406 11.03 1.20977 11.03 1.08985 10.9101C0.970048 10.7902 0.970048 10.5959 1.08985 10.4761L5.56572 5.99974L1.08985 1.52387C0.970048 1.40406 0.970048 1.20977 1.08985 1.08985C1.20976 0.970048 1.40405 0.970048 1.52387 1.08985Z"
                fill="black"
                stroke="black"
                stroke-width="0.234375"
              />
            </svg>
          )}
        </div>
      )}
      {/* {
                // showEmailError &&
                <div className="email-error">
                    {isItUndefined(global.field_marketo_email_error)  || 'Emails cannot match. Provide the customer contact information, including email, in the corresponding fields.'}
                </div>
            } */}
      {ctaPopUp && (!isSubmittedLocal || !isSubmitted) && (
        <div className={'form-header modal-header'}>
          <div>
            {!isSubmittedLocal ? (
              <p className={'cta-title'}>
                {isItUndefined(children.field_marketo_header_text)}
              </p>
            ) : null}
            {!isSubmittedLocal ? (
              <p className={'cta-subtitle'}>
                {isItUndefined(children.field_marketo_subtitle_text)}
              </p>
            ) : null}
          </div>
          {ctaPopUp && close !== undefined && (
            <svg
              onClick={() => {
                close();
              }}
              className={'escape'}
              alt={'escape'}
              width="12"
              height="12"
              viewBox="0 0 12 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M1.52387 1.08985L5.99974 5.56572L10.4761 1.08985C10.5959 0.970048 10.7902 0.970048 10.9101 1.08985C11.03 1.20976 11.03 1.40405 10.9101 1.52387L6.43375 5.99974L10.9101 10.4761C11.03 10.5959 11.03 10.7902 10.9101 10.9101C10.7902 11.03 10.5959 11.03 10.4761 10.9101L5.99974 6.43375L1.52387 10.9101C1.40406 11.03 1.20977 11.03 1.08985 10.9101C0.970048 10.7902 0.970048 10.5959 1.08985 10.4761L5.56572 5.99974L1.08985 1.52387C0.970048 1.40406 0.970048 1.20977 1.08985 1.08985C1.20976 0.970048 1.40405 0.970048 1.52387 1.08985Z"
                fill="black"
                stroke="black"
                stroke-width="0.234375"
              />
            </svg>
          )}
        </div>
      )}
      {close !== undefined && !ctaPopUp && (
        <svg
          onClick={() => {
            close();
          }}
          className={'escape'}
          alt={'escape'}
          width="12"
          height="12"
          viewBox="0 0 12 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M1.52387 1.08985L5.99974 5.56572L10.4761 1.08985C10.5959 0.970048 10.7902 0.970048 10.9101 1.08985C11.03 1.20976 11.03 1.40405 10.9101 1.52387L6.43375 5.99974L10.9101 10.4761C11.03 10.5959 11.03 10.7902 10.9101 10.9101C10.7902 11.03 10.5959 11.03 10.4761 10.9101L5.99974 6.43375L1.52387 10.9101C1.40406 11.03 1.20977 11.03 1.08985 10.9101C0.970048 10.7902 0.970048 10.5959 1.08985 10.4761L5.56572 5.99974L1.08985 1.52387C0.970048 1.40406 0.970048 1.20977 1.08985 1.08985C1.20976 0.970048 1.40405 0.970048 1.52387 1.08985Z"
            fill="black"
            stroke="black"
            stroke-width="0.234375"
          />
        </svg>
      )}
      {renderMessage()}
      <form style={{ display: showForm() }} id={'mktoForm_' + formId} />
    </>
  );
}
